<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue';
import { PrinterConnections } from '@posx/core';

const $props = defineProps<{
  modelValue?: string;
  rootFormData?: { connection_type?: string };
}>();

// Built-in kiosk driver name is not among this device's local printers, so it must be typed in manually
const isBuiltIn = computed(() => $props.rootFormData?.connection_type === PrinterConnections.WINDOWS_DRIVER_BUILT_IN);

const $emit = defineEmits(['change', 'update:modelValue']);
const value = ref($props.modelValue);
const printers = ref<NodePrinterInfo[]>([]);

// Fetch printers with typed response
onMounted(async () => {
  try {
    printers.value = await window.electronPrinter.getPrinters();
  } catch (error) {
    console.error('Failed to fetch printers:', error);
  }
});

const handleChange = () => {
  $emit('change', value.value);
  $emit('update:modelValue', value.value);
};
</script>

<template>
  <el-input v-if="isBuiltIn" v-model="value" @change="handleChange" />
  <el-select v-else v-model="value" @change="handleChange">
    <el-option
      v-for="printer in printers"
      :key="printer.name"
      :label="printer.name"
      :value="printer.name"
    ></el-option>
  </el-select>
</template>
